module.exports = __webpack_public_path__ + "static/CalibreMedium-48619aaa669be0b954bfb06907dce32d.woff";